import React from 'react';
import { Route } from 'react-router-dom';
import PrivateRoute from '../../containers/Routes/PrivateRouteContainer';
import globals from '../../globals/communityGlobals';
import _ from '../../utils/lodash';

const locale = globals.getArea('pageTitles');

class CommunityRoute {
  constructor(Component, Layout, featureAccess, pageTitleKey) {
    this.isPrivate = !!featureAccess;
    this.pageTitleKey = pageTitleKey;
    this.props = {
      Component,
      Layout,
      featureAccess,
      pageTitle: locale.getMsg(pageTitleKey),
    };
  }
  setRoutePath = routePath => {
    this.props.path = routePath;
    return this;
  };
  compose = () => {
    const { path, Component } = this.props;
    const key = `CommunityRoute${path}`;
    return this.isPrivate ? (
      <PrivateRoute exact key={key} {...this.props} />
    ) : (
      <Route key={key} path={path} render={props => <Component pageTitle={this.pageTitleKey} {...props} />} />
    );
  };
}

export function routeCreator(Component, Layout, requiredFeatureAccess, pageTitleKey) {
  // if (!React.isValidElement(Component) && typeof Component !== 'function') {
  //   throw new TypeError('Route build error: The provided component is neither a valid React element nor a function.');
  // }
  if (requiredFeatureAccess) {
    if (typeof requiredFeatureAccess !== 'string' && !Array.isArray(requiredFeatureAccess)) {
      throw new TypeError('Route build error: The provided requiredFeatureAccess is neither a string nor an array');
    }
    if (Array.isArray(requiredFeatureAccess) && requiredFeatureAccess.every(fA => typeof fA !== 'string')) {
      throw new TypeError('Route build error: The provided requiredFeatureAccess is not an array of strings.');
    }
  }
  if (pageTitleKey && typeof pageTitleKey !== 'string') {
    throw new TypeError('Route build error: The provided pageTitleKey is not a string.');
  }
  return new CommunityRoute(Component, Layout, requiredFeatureAccess, pageTitleKey);
}

export function buildNestedRouting(routeMap, parent = '') {
  let result = [];
  _.entries(routeMap).forEach(([path, routeObject]) => {
    if (routeObject instanceof CommunityRoute) {
      const isDefault = path === '_default';
      result.push(routeObject.setRoutePath(parent + (isDefault ? '' : path)).compose());
    } else {
      result = [...result, ...buildNestedRouting(routeObject, parent + path)];
    }
  });
  return result;
}

export default CommunityRoute;
